<template lang="pug">
  v-app
    v-content
      router-view
</template>

<script>
import Scrollbar from "smooth-scrollbar";
export default {
  name: "App",
  data: () => ({
    scrollbar: null
  }),
  mounted() {
    this.scrollbar = Scrollbar.init(document.querySelector("#app"), {damping: 0.18});
  }
};
</script>
<style>
/* asap-regular - latin */
@font-face {
  font-family: "Asap";
  font-style: normal;
  font-weight: 400;
  src: url("/font/asap-v9-latin-regular.eot"); /* IE9 Compat Modes */
  src: local("Asap Regular"), local("Asap-Regular"),
    url("/font/asap-v9-latin-regular.eot?#iefix") format("embedded-opentype"),
    /* IE6-IE8 */ url("/font/asap-v9-latin-regular.woff2") format("woff2"),
    /* Super Modern Browsers */ url("/font/asap-v9-latin-regular.woff")
      format("woff"),
    /* Modern Browsers */ url("/font/asap-v9-latin-regular.ttf")
      format("truetype"),
    /* Safari, Android, iOS */ url("/font/asap-v9-latin-regular.svg#Asap")
      format("svg"); /* Legacy iOS */
}

/* asap-700 - latin */
@font-face {
  font-family: "Asap";
  font-style: normal;
  font-weight: 700;
  src: url("/font/asap-v9-latin-700.eot"); /* IE9 Compat Modes */
  src: local("Asap Bold"), local("Asap-Bold"),
    url("/font/asap-v9-latin-700.eot?#iefix") format("embedded-opentype"),
    /* IE6-IE8 */ url("/font/asap-v9-latin-700.woff2") format("woff2"),
    /* Super Modern Browsers */ url("/font/asap-v9-latin-700.woff")
      format("woff"),
    /* Modern Browsers */ url("/font/asap-v9-latin-700.ttf") format("truetype"),
    /* Safari, Android, iOS */ url("/font/asap-v9-latin-700.svg#Asap")
      format("svg"); /* Legacy iOS */
}
#app {
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  background: #00B5CB;
}
</style>